// Component to render the profile card
// Import react
import React, { useState, useEffect } from "react";

// Import supabase configuration
import supabase from "../../config/supabase";
import { useRef } from "react";
// Import button
import { Buffer } from "buffer";
import Button from "../../components/button/button";

export default function Profile({
  profile,
  addCandidate = false,
  getId,
  currentProfile,
  onChangeDelete,boardProfiles,editClientRate
}) {

  const [url, setUrl] = useState("/blurry.svg");
  const [showInputBox, setShowInputBox] = useState(false);
  const [clientRate, setRate] = useState("");

  useEffect(() => {
    var rate = boardProfiles?.find(p => profile.id == p.id).rate;
    setRate(rate);
    },[])

    const onChange = (e) => {
        onChangeDelete(e, profile.id);
    }

    const editRate = (e,id,type) => {
        setRate(e.target.value);
        if (e.keyCode === 13 || type== "blur") {
            if(editClientRate){
                setShowInputBox(false);
                editClientRate(e.target.value,id)
            }
        }
    }

  const handleOnClick = (e) => {
    getId(e, profile.id);
  }

  return (
    // Function to render the content
    <div className="w-full h-auto relative container cursor-pointer" onClick={(e) => handleOnClick(e)}>
      {/* show image if profile is scheduled */}

      {/* Add card */}
      <div className={`rounded bg-white-1 shadow-clientCard h-auto grid grid-cols-12 gap-3 p-6 box-border ${currentProfile == profile ? 'border-blue-1 border-2' : ''} `}>

        {/* Column for avatar */}
        <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex items-center relative h-emoji w-emoji md:pt-10">
        {/* Render image if provided */}
        {profile.emoji_url ? (
            // Render imgae
            <img className="" src={profile?.emoji_url ? profile.emoji_url : url} />
        ) : (
            // Render placeholder
            <div className="w-emoji h-emoji bg-white-3 flex items-center">
            {/* Render text */}
            <div className="text-center w-full text-md font-text text-white-1 font-medium">
                {profile.full_name && profile.full_name[0].toUpperCase()}
            </div>
            </div>
        )}
        </div>

        {/* Column for details */}
        <div className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3">
        {/* Column for name and email*/}
        <div className="col-span-12">
            {/* Render name */}
            <div className="w-full text-lg font-text text-black-1 font-normal">
            {profile.full_name}
            </div>

        </div>

        {/* Column for email and exp */}
        <div className="col-span-6">
            {/* Render email */}
            {profile.email ? (
            <div className="w-full mb-4 text-sm font-light text-black-1 flex items-center">
 
                {/* email  */}
                {profile.email} 
            </div>
            ) : null}

            {/* Render exp */}
            {profile.exp ? (
            <div className="w-full text-xs font-normal text-black-2">
                <div>EXPERIENCE</div>
                <div className="text-black-1 text-sm">
                {/* Text */}
                {profile.exp} Years
                </div>
            </div>
            ) : null}
        </div>

        {/* Column for experience and contract */}
        <div className="col-span-6">
            {/* Render exp */}
            
            {/* Render expected_hourly_rate */}
            {profile.expected_hourly_rate ? (
            <div className="w-full text-sm font-semibold text-black-1 mt-8">
                <div className="text-black-2 text-xs font-normal"> HOURLY RATE</div>
                {/* Text */}
                <div>${profile.expected_hourly_rate}</div>
            </div>
            ) : null}
        </div>

        </div>
      </div>

    </div>
  );
}
